import gql from 'graphql-tag'
import { FILE_FRAGMENT } from '~/common/apollo/apollo.fragment'

export const CREDENTIAL_LIST_QUERY = gql`
	query credentialListQuery {
		workerCredentials {
			id
			esignUrl

			credential {
				id
				category
				atsSource
				default
				name
				completeType
				credentialCompleteUrl
				externalId
				changable
				instruction
				declinable
				fileSample {
					id
					updatedAt
					file {
						...fileFragment
					}
				}
			}
			files {
				id
				updatedAt
				file {
					...fileFragment
				}
			}
			number
			status
			state
			stateName
			expirationDate
			effectiveDate
			issuingAuthority
			licenseType
			submissionDate
			notes
			locations
		}
	}
	${FILE_FRAGMENT}
`

export const GET_USER_FORM_QUERY = gql`
	query userFormQuery($name: String!) {
		userForm(name: $name) {
			status
			userId
			wizardForm {
				name
				quizzes {
					name
					questionsCount
					quizQuestions {
						id
						name
						questionType
						questionOptions
						question
						requiredNoteIf
						description
						isOptional
					}
				}
			}
			wizardFormId
		}
	}
`

export const CREDENTIAL_UPDATE_MUTATION = gql`
	mutation updateWorkerCredential(
		$id: String
		$state: String
		$issuingAuthority: String
		$files: [DocumentInput!]
		$number: String
		$licenseType: String
		$expirationDate: ISO8601DateTime
		$effectiveDate: ISO8601DateTime
		$submissionDate: ISO8601DateTime
		$notes: String
		$status: WorkerCredentialStatusEnum
		$locations: [String!]
	) {
		updateWorkerCredential(
			id: $id
			state: $state
			files: $files
			issuingAuthority: $issuingAuthority
			number: $number
			licenseType: $licenseType
			expirationDate: $expirationDate
			effectiveDate: $effectiveDate
			submissionDate: $submissionDate
			notes: $notes
			status: $status
			locations: $locations
		) {
			id
			status
			state
			files {
				file {
					id
					fileUrl
				}
			}
		}
	}
`

export const SIGN_JOTfORM_MUTATION = gql`
	mutation markSignedWorkerCredentialMutation($id: String!) {
		markSignedWorkerCredential(id: $id) {
			success
		}
	}
`

export const GET_WORKER_CREDENTIAL_QUERY = gql`
	query workerCredential($id: String!) {
		workerCredential(id: $id) {
			id
			credential {
				id
				fileSample {
					id
					updatedAt
					file {
						id
						filename
						fileUrl
						blobId
						byteSize
						contentType
						imageUrls(size: ["100x100", "200x200", "500x500"])
					}
				}
			}
			files {
				id
				updatedAt
				file {
					id
					filename
					fileUrl
					blobId
					byteSize
					contentType
					imageUrls(size: ["100x100", "200x200", "500x500"])
				}
			}
		}
	}
`
